import { fallbackImg, LikeIcon } from '../../base'
import Rupee from './Rupee'
import Stars from './Stars'

function ProductPlaceholder() {

    const arr = [0, 1, 2, 3, 4, 5]

    return (

        <div style={{ display: 'flex', gap: '30px', width: '100%', marginTop: '50px', overflowX: 'scroll', scrollbarWidth: 'none' }}>
            {
                arr.map((item, index) => {
                    return <div key={index}>
                        <div className={`productCard`} style={{ opacity: '0.4' }} disabled  >
                            <div className='imgdiv'>
                                <img src={fallbackImg} />
                            </div>
                            <div className='detail'>
                                <h6 className='h7 truncate-2 name mt-1' style={{ cursor: 'pointer' }} >Loading....</h6>
                                <h6 className='h6 heading d-flex gap-2' style={{ alignItems: 'center' }}><Rupee amount={'000'} /><span> ( 0% off )</span></h6>
                                <h6 className='h7 d-flex gap-2' style={{ alignItems: 'center' }}>MRP : <del className='h7 me-2'><Rupee amount={'000'} /></del><Stars rating={0} reviews={0} /></h6>
                                <div className='w-100 d-flex'>
                                    <div className='d-flex w-100' >
                                        <button className='secondryButton h7 pt-1 pb-1  mt-0 mb-0 w-100' disabled={true}>Added To Cart</button>
                                        <button style={{ position: 'absolute', bottom: '75px', right: '7px' }} className='iconSpan' disabled={true}><LikeIcon /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                })
            }

        </div>
    )
}

export default ProductPlaceholder